import { ILineInfoLite, ILineInfoLiteData } from "./lineInfoLite.types";
import { LineTypeCode } from "@/types";
import { ITurnLite } from "./turnLite.types";
import useGetLineRouteName from "@/use/useGetLineRouteName";

export class LineInfoLite implements ILineInfoLite {
  readonly id: string;
  readonly lineNum: string;
  readonly routeName: string;
  readonly lineTypeCode: LineTypeCode;
  readonly lineTypeName: string;
  readonly displayMethodCode: string;
  readonly turns: ITurnLite[];
  readonly lineNameDisplayText: string;

  constructor(data: ILineInfoLiteData) {
    this.id = data.id;
    this.lineNum = data.lineNum;
    this.routeName = data.routeName;
    this.lineTypeCode = data.lineTypeCode;
    this.lineTypeName = data.lineTypeName;
    this.displayMethodCode = data.displayMethodCode;
    this.turns = data.turns;
    this.lineNameDisplayText = useGetLineRouteName(
      data.lineTypeCode,
      data.routeName,
      data.lineNum
    );
  }
}
